import { NodeModel } from "../_model/NodeModel";
import { DecorationFilter3 } from "../filter3/decorationFilter3";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Filter3 extends NodeModel {
    constructor() {
        super("Filter3");

        this.type = new Types().Filter3;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 90;
        this.width = 90;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Fluxogramas/filtro3.png");
        this.data = [new Properties({...this })];
        this.CurrentTempAr = null
        this.jokerCaption = [];


        this.decorate = async function(callback) {
            this.decorator = new DecorationFilter3();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new Filter3()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null
            cloned.CurrentTempAr = this.CurrentTempAr
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.jokerCaption = this.jokerCaption
            cloned.data = this.data.map(d => d.clone());

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.jokerCaption = node.jokerCaption
            this.data = node.data.map(d => new Properties({...d }));
            this.CurrentTempAr = node.CurrentTempAr
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }
            if (node.CurrentTempAr) {
                this.CurrentTempAr = node.CurrentTempAr;
            }
            this.jokerCaption = node.jokerCaption;
        }
    }
}

export { Filter3 };